import { useEffect, useRef, useState } from 'react';

export const useDebouncedValue = (value, wait, options = { leading: false }) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const ref = useRef({ mounted: false, timeout: null, cooldown: false });

  const cancel = () => clearTimeout(ref.current.timeout);

  useEffect(() => {
    if (ref.current.mounted) {
      if (!ref.current.cooldown && options.leading) {
        ref.current.cooldown = true;
        setDebouncedValue(value);
      } else {
        cancel();
        ref.current.timeout = setTimeout(() => {
          ref.current.cooldown = false;
          setDebouncedValue(value);
        }, wait);
      }
    }
  }, [value, options.leading, wait]);

  useEffect(() => {
    ref.current.mounted = true;
    return cancel;
  }, []);

  return [debouncedValue, cancel];
};
